export * from "-!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./LotesList.vue?vue&type=template&id=374db9d5&"


//////////////////
// WEBPACK FOOTER
// ./src/components/Modules/LotesList.vue?vue&type=template&id=374db9d5&
// module id = null
// module chunks = 